import React, { useState, useEffect } from "react";

import LogoWsaBranca from "../assets/img/wsa_logo_2015_rgb_branca.png";
import LogoGame from "../assets/img/logo-game.svg";
import LogoUcs from "../assets/img/logo-ucs.svg";
import LogoSebrae from "../assets/img/logo-sebrae.svg";
import { keycloak } from "../components/auth";
import { getUserSession } from "../services/user-service";

export default function LoginApp(props) {
  const [showLoginForm, setShowLoginForm] = useState(0);

  let openLogin = () => {
    props.history.push("/login");

    if (keycloak.authenticated) {
      getUserSession().then((res) => {
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        window.GLOBALS.user.info = res.data;
        localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

        props.history.push("/tab/jogo");
      });
    }
  };

  useEffect(() => {
    setShowLoginForm(true);
  }, []);

  return (
    <div className="menu-content pane">
      <div className="view-container">
        <div className="view-login pane pane-game">
          <div className="scroll-content ionic-scroll">
            <div className="scroll">
              <img
                src={LogoWsaBranca}
                className="logo-wsa"
                alt="logo wsa branca"
              />

              <img src={LogoGame} className="logo-game" alt="logo game" />
              <form style={{ opacity: showLoginForm ? 1 : 0 }}>
                <button
                  className="button"
                  ng-disabled="!showLoginForm"
                  type="submit"
                  onClick={openLogin}
                >
                  Entrar
                </button>
              </form>
              <div className="footer">
                <div className="row">
                  <div className="col text-center">
                    <img src={LogoUcs} className="logo-ucs" alt="logo ucs" />
                  </div>
                  <div className="col text-center">
                    <img
                      src={LogoSebrae}
                      className="logo-sebrae"
                      alt="logo sebrae"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
